 /* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';
import { Storage } from '@capacitor/storage';
import { Storage as SecureStorage} from '@ionic/storage-angular';
import * as _ from 'lodash';

export interface Session {
  lastUpdate: Date;
}

@Injectable({
  providedIn: 'root'
})

export class StorageService {
  private _storage: SecureStorage | null = null;
  constructor(
    private storage: SecureStorage
  ) {
    this.init();
  }

  async init() {
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    if (!this._storage) {
      const storage = await this.storage.create();
      this._storage = storage;
    }
  }

  // Create and expose methods that users of this service can
  // call, for example:
  public set(key: string, value: any) {
    return this._storage?.set(key, value);
  }

  public get(key) {
    return this._storage?.get(key);
  }

  public async clear() {
    await Storage.clear();
  }
  /**
   * getSession restituisce la sessionne utente
   * @returns Promise<Session>
   */
  public async getSession(): Promise<Session> {
    const { value } = await Storage.get({ key: 'session' });
    return JSON.parse(value);
  }

  /**
   * setSession
   * setta la sessione
   */
   public async setSession(session: Session) {
    await Storage.set({
      key: 'session',
      value: JSON.stringify(session),
    });
  }
}
